import React from "react";
import {
  ConfigProvider,
  Table as AntTable,
  TableProps as AntTableProps,
} from "antd";
import styled from "styled-components";
import EmptyBoxComp from "../../molecures/EmptyBox";

export interface TableProps extends AntTableProps<any> {
  verticalAlign?: string;
}

const Table: React.FC<TableProps> = (props: TableProps) => {
  const {
    loading = false,
    rowKey = "id",
    size = "large",
    sticky = false,

    dataSource = [],
    ...rest
  } = props;

  const renderEmpty = () => {
    if (dataSource.length === 0) return <EmptyBoxComp />;
    return false;
  };
  return (
    <ConfigProvider renderEmpty={renderEmpty}>
      <StyledTable
        loading={loading}
        rowKey={rowKey}
        size={size}
        sticky={sticky}
        dataSource={dataSource}
        {...rest}
      />
    </ConfigProvider>
  );
};
const StyledTable = styled(AntTable)<TableProps>`
  td {
    vertical-align: ${({ verticalAlign }) => verticalAlign || "top"};
  }
`;

Table.defaultProps = { style: { width: "100%" } };
export default Table;
